import { dashboardApi } from '@/api';
import { queryOptions } from '@tanstack/react-query';

export interface CachedOptimizationResult {
    optimalSpends: Record<string, number>;
    budget: number | null;
    timestamp: string;
}

export interface CachedOptimizationResponse {
    result: CachedOptimizationResult | null;
}

const getCachedOptimization = async (
    projectId: string,
    dashboardId: string,
) => {
    return dashboardApi<CachedOptimizationResponse>({
        method: 'GET',
        url: `/front-office/project/${projectId}/dashboard/${dashboardId}/cached-optimization`,
    });
};

export const cachedOptimizationQueryOptions = (
    projectId: string,
    dashboardId: string,
) =>
    queryOptions({
        queryKey: ['cached-optimization', projectId, dashboardId],
        queryFn: () => getCachedOptimization(projectId, dashboardId),
        staleTime: Infinity,
    });
